import {
  Button,
  Tooltip,
} from '@mui/material';
import { string } from 'prop-types';
import { useContext, useRef } from 'react';

import { LocalizationContext } from 'src/contexts/LocalizationContext';

function HeaderLanguage() {
  const { strings, language, toggleLanguage } = useContext(LocalizationContext);

  const ref = useRef<any>(null);
  const iconENUS = '/static/images/enus.png';
  const iconPTBR = '/static/images/ptbr.png';

  //   language === 'pt-BR'
  //     ? require('assets/enus.png')
  //     : require('assets/ptbr.png');


  return (
    <>
      <Tooltip arrow title={strings.language}>
        <Button color="primary" ref={ref} onClick={toggleLanguage}>
          <img
            src={language==='en-US'? iconPTBR: iconENUS}
            width={20}
            height={20}
            alt={strings.language}
          />
        </Button>
      </Tooltip>
    </>
  );
}

export default HeaderLanguage;

